module.exports = __webpack_public_path__ + "img/tasks.82eeb76c.png";